module.exports = __webpack_public_path__ + "media/images/promotions/cards/fate-4-8b9165085c09599a43a1da56cb65f1ab.svg";